import { CampaignAPI } from "generated-api"

export type ICampaignSchedule = NonNullable<Awaited<ReturnType<typeof CampaignAPI.getApiCampaignSchedule>>>

export enum WEATHERS {
  THUNDERSTORM = "thunderstorm",
  DRIZZLE = "drizzle",
  RAIN = "rain",
  SNOW = "snow",
  ATMOSPHERE = "atmosphere",
  CLEAR = "clear",
  CLOUDS = "clouds"
}
export const ALL_WEATHERS: WEATHERS[] = [
  WEATHERS.THUNDERSTORM,
  WEATHERS.DRIZZLE,
  WEATHERS.RAIN,
  WEATHERS.SNOW,
  WEATHERS.ATMOSPHERE,
  WEATHERS.CLEAR,
  WEATHERS.CLOUDS
]

export interface IWeather {
  id: number
  weather_id: WEATHERS
}

export const SCHEDULE_DAY_BY_INDEX: { [index: number]: keyof ICampaignSchedule } = {
  0: "sunday",
  1: "monday",
  2: "tuesday",
  3: "wednesday",
  4: "thursday",
  5: "friday",
  6: "saturday"
}

export interface ICampaignScheduleFormItem {
  start: Date
  end: Date
}

export interface IItemByDay {
  day: number
  items: ICampaignScheduleFormItem[]
}

export interface IScheduleRepository {
  getSchedule(campaignId: number): Promise<ICampaignSchedule | null>
  createSchedule(campaignId: number, schedule: ICampaignSchedule): Promise<void>
  updateSchedule(campaignId: number, schedule: ICampaignSchedule): Promise<void>
  deleteSchedule(campaignId: number): Promise<void>
  getAvailableWeathers(): Promise<IWeather[]>
  getWeathers(campaignId: number): Promise<IWeather[]>
  createWeather(campaignId: number, weather: WEATHERS): Promise<IWeather>
  deleteWeather(campaignId: number, weatherId: number): Promise<void>
}

export interface IScheduleState {
  weathers: IWeather[]
}
